import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const trashPlansRoute: InvariantJiraRoute = {
	name: 'trash-plans-directory',
	path: '/jira/plans/settings/trash',
	exact: true,
};
